<template>
  <div id="wrapper-app">
    <router-view />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'app',
  methods: {
    ...mapActions('settings', ['getCoreSettings', 'getHomeSettings'])
  },
  created () {
    this.getCoreSettings()
    this.getHomeSettings()
  }
}
</script>

<style lang="sass">
  @import "@/sass/_lumbre.sass"
</style>
